// services/payment.ts
import { apiClient } from './api';
import { PaymentRequest, PaymentResponse, Transaction, Balance, CardTopUpRequest, PaymentRecieved, PaymentIssueRequest } from '../types';
import { CardPaymentInitiateResponse, PaymentStatusResponse } from '../types';

export const paymentService = {
  makePayment: async (request: PaymentRequest): Promise<PaymentResponse> => {
    const response = await apiClient.post<PaymentResponse>('/payments', request);
    return response.data;
  },

  getTransactions: async (studentId?: number): Promise<Transaction[]> => {
    const url = studentId ? `/payments/transactions?studentId=${studentId}` : '/payment/transactions';
    const response = await apiClient.get<Transaction[]>(url);
    return response.data;
  },

  getUserTransactions: async (): Promise<Transaction[]> => {
    const response = await apiClient.get<Transaction[]>('/payment/transactions');
    console.log(response.data);
    return response.data;
  },

  getBalance: async (studentId: number): Promise<Balance> => {
    const response = await apiClient.get<Balance>(`/payments/balance/${studentId}`);
    return response.data;
  },

  topUpBalance: async (studentId: number, amount: number): Promise<Balance> => {
    const response = await apiClient.post<Balance>(`/payments/`, { studentId, amount });
    return response.data;
  },

  generateTopUpQR: async (request: CardTopUpRequest): Promise<PaymentResponse> => {
    const response = await apiClient.post<PaymentResponse>('/payment/get-topup-qr', request);
    console.log('QR Response:', response);
    return response.data;
  },

  getPaymentMethods: async (): Promise<any[]> => {
    const response = await apiClient.get<any[]>('/payments/methods');
    return response.data;
  },

  // Updated verification method with new parameters
  verifyPayment: async (studentId: string, transactionReference: string, amount: number): Promise<PaymentRecieved> => {
    const response = await apiClient.get<PaymentRecieved>(
      `/payment/verifyTopup?sid=${studentId}&transactiontransactionReference=${transactionReference}&amount=${amount}`
    );
    console.log(response.data);
    return response.data;
  },
 
 
  reportPaymentIssue: async (data: PaymentIssueRequest) => {
  const response = await apiClient.post('/payment/report-issue', data);
  return response.data;
},


   initiateCardPayment: async (data: any): Promise<CardPaymentInitiateResponse> => {
    const res = await apiClient.post<CardPaymentInitiateResponse>(
      '/card-payment/initiate',
      data
    );
    return res.data;
  },

  getPaymentStatus: async (basketId: string): Promise<PaymentStatusResponse> => {
    const res = await apiClient.get<PaymentStatusResponse>(
      `/card-payment/status/${basketId}`
    );
    return res.data;
  }

};